import { fmhNpiAPI, PAYER_REQUEST_API_URL } from 'api/APIBase';

/** Gets attachment for a payer request */
export async function getRequestAttachment({
    payerId,
    requestId,
    requestAttachmentId,
}: {
    payerId: string;
    requestId: string;
    requestAttachmentId: string;
}) {
    const url = `${PAYER_REQUEST_API_URL}/${payerId}/requests/${requestId}/attachment/${requestAttachmentId}`;
    return fmhNpiAPI({ url, payerId }).get().blob();
}
